import { createContext, useContext, useState } from 'react';

interface ResponseData {
  operated?: string;
}

interface ResponseContextType {
  responseData?: ResponseData;
  setResponseData: (data: ResponseData) => void;
}

const ResponseContext = createContext<ResponseContextType | undefined>(undefined);

export const ResponseProvider = ({ children }: { children: React.ReactNode }) => {
  const [responseData, setResponseData] = useState<ResponseData | undefined>(undefined);

  return (
    <ResponseContext.Provider value={{ responseData, setResponseData }}>
      {children}
    </ResponseContext.Provider>
  );
};

export const useResponseData = () => {
  const context = useContext(ResponseContext);
  if (!context) {
    throw new Error('useResponseData must be used within a ResponseProvider');
  }
  return context;
};
